/* This variable is for filter unique value from customization */ 
var searchSpringUniqueTag = UniqueTagList;

/* Searchspring Beacon 2.0 - autocomplete tracking */
var ssPageLoadId = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : null;
var ssAutocompleteResponseId = null;

// NOTE - the source of truth for the configuration of this tracking call is src/lib/searchspringBeacon.js
// TODO -This Liquid file should be replaced with JS so we can import src/lib/searchspringBeacon.js
function sendAutocompleteBeacon(siteId, responseId, uid, pageLoadId) {
  if (!siteId || !responseId || !uid || !pageLoadId) return;

  var payload = {
    context: {
      timestamp: new Date().toISOString(),
      pageUrl: window.location.href,
      userId: getSearchSpringCookie('ssUserId'),
      sessionId: getSearchSpringCookie('ssSessionIdNamespace'),
      pageLoadId: pageLoadId,
      userAgent: navigator.userAgent,
      initiator: 'james-perse-theme/1.0.0',
    },
    data: {
      responseId: responseId,
      results: [{ type: 'product', parentId: uid, uid: uid }],
    },
  };

  var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
  if (currency) payload.context.currency = { code: currency };

  try {
    fetch(
      'https://analytics.searchspring.net/beacon/v2/' + siteId + '/autocomplete/clickthrough',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }
    );
  } catch (e) {
    console.error('[Searchspring Beacon]', e);
  }
}

var searchSpringUniqueTagArr = searchSpringUniqueTag.split(',').filter(value => value !== "");

/* Flag for apply customization unique logic */
var searchSpringUniqueTagArrLogic = enableUniqueFilter;

/* Flag for search page filter count */
var searchPageCountflag = true;
/* Flag for collection page filter count */
var collectionPageCountflag = true;

/* array for exclude filter from search page */
var arrFilterRemoveSearch = [];

/* Search-Page constant */
var searchPageRedirection = searchPageUrlHandle;

var featuredProductArr = [];

var suggestApiFlagNoRes = false;
var searchResultFlagNoRes = false;

/* ==============  Function for validate and create cookie for Search Spring Start   ============== */

function getSearchSpringCookie(cookieName) {
    var cookies = document.cookie.split(';');
    for(var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName + '=') === 0) {         
            return cookie.substring(cookieName.length + 1, cookie.length);
        }
    }
    return null;
}

function setSearchSpringCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function setSearchSpringCookieForSession(name, value) {
    document.cookie = name + "=" + (value || "") + "; path=/";
}

function collectionSizeChart(){
  $(".tt-col-item").each(function(index){
  	var objthis = $(this);
  	if(!objthis.hasClass('itemCalled')){
  		var size_content= objthis.find(".tt-option-block .size-move-data" ).html();
  		objthis.find(".size-variant").append(size_content);
  		objthis.addClass("itemCalled");
  	}
  });


  /* Collection Page OnClick of product image */
  if( $('.tt-title a').length > 0 ) {
    $('.tt-title a').each(function(){
      if(!$(this).hasClass('image-title-loaded')){
        $(this).attr('class', 'image-title-loaded');
        $(this).on('click', function(){
            var productId = $(this).parents('div[class^="tt-col-item"]').attr('data-product-id');
            var cookieValue = productId+"##"+collectionName+"##/collections/"+collectionHandle;            
            document.cookie = "prod_col_breadcrub=" + cookieValue + ";" + ";path=/";
        });
      }
    });
  }
  if( $('.img-link').length > 0 ) {
    $('.img-link').each(function(){
      if(!$(this).hasClass('image-loaded')){
        $(this).attr('class', 'image-loaded');
        $(this).on('click', function(){
            var productId = $(this).parents('div[class^="tt-col-item"]').attr('data-product-id');
            var cookieValue = productId+"##"+collectionName+"##/collections/"+collectionHandle;            
            document.cookie = "prod_col_breadcrub=" + cookieValue + ";" + ";path=/";
        });
      }
    });
  }
}

function validateAndCreateCookie(){
  var cookieName1 = "_isuid";
  var cookieName2 = "ssUserId";
  var cookieName3 = "ssSessionIdNamespace";
  
  var cookieValue1 = self.crypto.randomUUID();
  var cookieValue2 = cookieValue1;
  var cookieValue3 = self.crypto.randomUUID();
  
  var cookieExists1 = getSearchSpringCookie(cookieName1);
  var cookieExists2 = getSearchSpringCookie(cookieName2);
  var cookieExists3 = getSearchSpringCookie(cookieName3);
  
  if (cookieExists1 === null) {
    setSearchSpringCookie(cookieName1, cookieValue1, 365);
  }
  if (cookieExists2 === null) {
    setSearchSpringCookie(cookieName2, cookieValue2, 365);
  }
  if (cookieExists3 === null) {
    setSearchSpringCookieForSession(cookieName3, cookieValue3);
  }  
}


function manageSearchSpringCookie(){
  validateAndCreateCookie(); 
}

function getCollectionTouts(){
  var promoHTML = "";
  if(typeof(collectionTouteDesktop) != 'undefined' && collectionTouteDesktop.length > 0){
    collectionTouteDesktop.forEach(promo => {
      if (promo.position === "last") {
        const startTag = promo.link !== "" ? 
          `<a href="${promo.link}" title="${promo.title}" class="desktop-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${promo.position + 1}" data-tile-position="${promo.position}">` : 
          `<div class="desktop-item grid-tile collectionToute tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${promo.position}" data-tile-position="${promo.position}">`;
        const linkContent = (promo.link !== "" && promo.cta_text !== "") ? `<span class="btn btn--secondary" title="${promo.cta_text}">${promo.cta_text}</span>` : "";
        const endTag = promo.link !== "" ? "</a>" : "</div>";
        promoHTML += 
          `${startTag}
            <div class="desktop-item grid-item last-item" style="background-image: url('${promo.image}'); background-color: ${promo.background_color || "#484646"};position: relative;">
              ${promo.video !== '' && promo.mux_playback_id === '' ? promo.video : ""}
              ${promo.video === '' && promo.mux_playback_id !== '' ? `<mux-player playback-id="${promo.mux_playback_id}" autoplay="any" loop></mux-player>` : ""}
              <img class="lazyload" style="width: 100%; visibility: hidden;" src="" alt="">
              ${promo.video !== '' || promo.mux_playback_id !== '' ? `<div class="grid-item__tile-height"></div>` : ''}
              <div class="grid-item__tile-inner ${promo.video !== '' || promo.mux_playback_id !== '' ? " tile-absolute" : ""}" style="color: ${promo.text_color || "#fff"}; position: absolute; top: 0; bottom: 0; left: 0; right: 0;">
                ${promo.title !== "" ? `<span class="title">${promo.title}</span>` : ""}
                ${promo.text !== "" ? `<p>${promo.text}</p>` : ""}
                ${linkContent}
              </div>
            </div>
          ${endTag}`;
      } else {
        const tile_position = parseInt(promo.position);
        const startTag = promo.link !== "" ? 
          `<a href="${promo.link}" title="${promo.title}" class="desktop-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${tile_position + 1}" data-tile-position="${tile_position}">` : 
          `<div class="desktop-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${tile_position + 1}" data-tile-position="${tile_position}">`;   
        const linkContent = (promo.link !== "" && promo.cta_text !== "") ? `<span class="btn btn--secondary" title="${promo.cta_text}">${promo.cta_text}</span>` : "";
        const endTag = promo.link !== "" ? "</a>" : "</div>";
        promoHTML += 
          `${startTag}
          <div class="grid-item" style="background-image: url('${promo.image}'); background-color: ${promo.background_color || "#484646"};">
            ${promo.video !== '' && promo.mux_playback_id === '' ? promo.video : ""}
            ${promo.video === '' && promo.mux_playback_id !== '' ? `<mux-player playback-id="${promo.mux_playback_id}" autoplay="any" loop></mux-player>` : ""}
            ${promo.video !== '' || promo.mux_playback_id !== '' ? `<div class="grid-item__tile-height"></div>` : ''}
            <div class="${promo.video !== '' || promo.mux_playback_id !== '' ? "grid-item__tile-inner tile-absolute" : "grid-item__tile-inner"}" style="color: ${promo.text_color || "#fff"};">
              ${promo.title !== "" ? `<span class="title">${promo.title}</span>` : ""}
              ${promo.text !== "" ? `<p>${promo.text}</p>` : ""}
              ${linkContent}
            </div>
          </div>
        ${endTag}`;
      }
    });
  }

  var promoHTML_Mob = "";
  if(typeof(collectionTouteMobile) != 'undefined' && collectionTouteMobile.length > 0){
    collectionTouteMobile.forEach(promo => {
      if (promo.position === "last") {
        const startTag_mob = promo.link !== "" ? 
          `<a href="${promo.link}" title="${promo.title}" class="mobile-item grid-tile collectionToute tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${promo.position + 1}" data-tile-position="${promo.position}">` : 
          `<div class="mobile-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${promo.position}" data-tile-position="${promo.position}">`;
        const linkContent_mob = (promo.link !== "" && promo.cta_text !== "") ? `<span class="btn btn--secondary" title="${promo.cta_text}">${promo.cta_text}</span>` : "";
        const endTag_mob = promo.link !== "" ? "</a>" : "</div>";
        promoHTML_Mob += 
          `${startTag_mob}
            <div class="grid-item last-item mobile-item" style="background-image: url('${promo.image}'); background-color: ${promo.background_color || "#484646"};position: relative;">
              ${promo.video !== '' && promo.mux_playback_id === '' ? promo.video : ""}
              ${promo.video === '' && promo.mux_playback_id !== '' ? `<mux-player playback-id="${promo.mux_playback_id}" autoplay="any" loop></mux-player>` : ""}
              <img class="lazyload" style="width: 100%; visibility: hidden;" src="" alt="">
              <div class="grid-item__tile-inner ${promo.video !== '' || promo.mux_playback_id !== '' ? " tile-absolute" : ""}" style="color: ${promo.text_color || "#fff"}; position: absolute; top: 0; bottom: 0; left: 0; right: 0;">
                ${promo.title !== "" ? `<span class="title">${promo.title}</span>` : ""}
                ${promo.text !== "" ? `<p>${promo.text}</p>` : ""}
                ${linkContent_mob}
              </div>
            </div>
          ${endTag_mob}`;
      } else {
        const tile_position_mob = parseInt(promo.position);      
        const startTag_mob = promo.link !== "" ? 
          `<a href="${promo.link}" title="${promo.title}" class="mobile-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${tile_position_mob + 1}" data-tile-position="${tile_position_mob}">` : 
          `<div class="mobile-item collectionToute grid-tile tt-col-item tile-span-${promo.tile_width || 1}-${promo.tile_height || 1}" data-position="${tile_position_mob + 1}" data-tile-position="${tile_position_mob}">`;  
        const linkContent_mob = (promo.link !== "" && promo.cta_text !== "") ? `<span class="btn btn--secondary" title="${promo.cta_text}">${promo.cta_text}</span>` : "";
        const endTag_mob = promo.link !== "" ? "</a>" : "</div>";
        promoHTML_Mob +=
          `${startTag_mob}
            <div class="grid-item" style="background-image: url('${promo.image}'); background-color: ${promo.background_color || "#484646"};">                      
              ${promo.video !== '' && promo.mux_playback_id === '' ? promo.video : ""}
              ${promo.video === '' && promo.mux_playback_id !== '' ? `<mux-player playback-id="${promo.mux_playback_id}" autoplay="any" loop></mux-player>` : ""}
              <div class="grid-item__tile-inner ${promo.video !== '' || promo.mux_playback_id !== '' ? "tile-absolute" : ""}" style="color: ${promo.text_color || "#fff"};">
                ${promo.title !== "" ? `<span class="title">${promo.title}</span>` : ""}
                ${promo.text !== "" ? `<p>${promo.text}</p>` : ""}
                ${linkContent_mob}
              </div>
            </div>
          ${endTag_mob}`;
      }
    });
  }
  
  var parser = new DOMParser();
  var promoHTMLParse = parser.parseFromString(promoHTML, 'text/html');
  var promoHTMLParse_Mob = parser.parseFromString(promoHTML_Mob, 'text/html');
  return { promoHTMLParse, promoHTMLParse_Mob };
}

/* ==============  Function for get params for Search Spring start   ============== */
function getFilterParams(url) {
    const queryString = url.split('?')[1];
    const filterParams = [];
    const sortParams = [];
    const featuredParams = [];
    if (queryString) {
        const params = queryString.split('&');
        params.forEach(param => {
            const [key, value] = param.split('=').map(decodeURIComponent);            
            if (key.startsWith('filter.')) {
                filterParams.push(`${key}=${value}`);                                
            }
            if (key.startsWith('sort.')) {
                sortParams.push(`${key}=${value}`);                                
            }
            if (key.startsWith('featured')) {
                featuredParams.push(`${key}=${value}`);                                
            }           
        });
    }      
    const filterURL = filterParams.join('&');
    const sortURL = sortParams.join('&');
    const featuredURL = featuredParams.join('&');    
    return { filterURL, sortURL, featuredURL};
}
/* ==============  Function for get params for Search Spring end   ============== */


/* ==============  Function for product data after get responce of SearchSpringAPI end   ============== */


/* ==============  Function for common data after get responce of SearchSpringAPI start   ============== */
function manageCommonData(arrCommonData){  
  if(arrCommonData['apiRequestData'] == 'trending'){
      /* render trending data - start */  
      if(arrCommonData['responseResultData']['trending']['queries'].length > 0){
        var queryDataArr = arrCommonData['responseResultData']['trending']['queries'];        
        var trendingSearchTerm = '';
        var trendingSearchTermMob = '';
        var trending_remove_terms_arr = searchSpring_trending_remove_terms.toLowerCase().split(",");
        var trending_update_terms_arr = searchSpring_trending_update_terms.toLowerCase().split(",");
        var keyValueArray = {};
        if (trending_update_terms_arr.length > 0) {            
            trending_update_terms_arr.forEach(terms => {
                var [key, value = ""] = terms.split(':').map(item => item.trim());
                keyValueArray[key.trim()] = value;
            });
        }
        for( var prokey in  queryDataArr ){
          var queryData = queryDataArr[prokey];
          if(trending_remove_terms_arr.length > 0){
            if(trending_remove_terms_arr.includes(queryData.searchQuery.toLowerCase())){            
              continue;
            }
          }
          var searchTerms = queryData.searchQuery.toLowerCase();
          if (Object.keys(keyValueArray).length > 0 && keyValueArray.hasOwnProperty(searchTerms)) {
              searchTerms = keyValueArray[searchTerms];
          }
          trendingSearchTerm += `<li class="nav-item"><a href="/pages/${searchPageRedirection}?q=${searchTerms}" title="${searchTerms}">${searchTerms}</a></li>`;
          trendingSearchTermMob += `<li class="mobile-nav-item"><a href="/pages/${searchPageRedirection}?q=${searchTerms}" title="${searchTerms}">${searchTerms}</a></li>`
        }        
        $(".search-seggestion-outer .search-navList.trending-search").html(trendingSearchTerm);
        $(".mobile-search-suggest-outer .mobile-search-inner-trending .mobile-search-navList").html(trendingSearchTermMob);
      }else{
        var queryDataArr = [
            { "searchQuery": "shirt", "popularity": 1 },
            { "searchQuery": "pent", "popularity": 2 },      
        ];
        var trendingSearchTerm = '';
        var trendingSearchTermMob = '';
        for( var prokey in  queryDataArr ){
          var queryData = queryDataArr[prokey];      
          trendingSearchTerm += `<li class="nav-item"><a href="/pages/${searchPageRedirection}?q=${queryData.searchQuery}" title="${queryData.searchQuery}">${queryData.searchQuery}</a></li>`;
          trendingSearchTermMob += `<li class="mobile-nav-item"><a href="/pages/${searchPageRedirection}?q=${queryData.searchQuery}" title="${queryData.searchQuery}">${queryData.searchQuery}</a></li>`
        }
        $(".search-seggestion-outer .search-navList.trending-search").html(trendingSearchTerm);        
        $(".mobile-search-suggest-outer .mobile-search-inner-trending .mobile-search-navList").html(trendingSearchTermMob);
      }
      /* render trending data - end */
  }
  
  if(arrCommonData['apiRequestData'] == 'trendingProductRec'){
    /* render trending product data - start */      
      if(arrCommonData['responseResultData'][0]['results'].length > 0){
        var trendingProduct = '';
        var queryDataArr = arrCommonData['responseResultData'][0]['results'];
        for( var prokey in  queryDataArr ){
          var queryData = queryDataArr[prokey];          
          jQuery.getJSON(window.Shopify.routes.root + 'products/'+ queryData.mappings.core.url+'.js', function(product) { 

            if(cartCurrencySymbol == "$"){
              $(`.search-trending-product .trending-product-${product.id}`).html(Shopify.formatMoney(product.price, money_format) +" "+ localizationCurrecyCode);
              $(`.search-trending-product .product-match-compare-price-trending.search-product-${product.id}`).html(Shopify.formatMoney(product.compare_at_price, money_format) +" "+ localizationCurrecyCode);              
            }else{
              $(`.search-trending-product .trending-product-${product.id}`).html(Shopify.formatMoney(product.price, money_format));
              $(`.search-trending-product .product-match-compare-price-trending.search-product-${product.id}`).html(Shopify.formatMoney(product.compare_at_price, money_format));
            }
            if(parseInt(product.compare_at_price) > parseInt(product.price) ){
              $(`.search-trending-product .product-match-compare-price-trending.search-product-${product.id}`).removeClass('hide');
            }
          });
          trendingProduct += `<div class="search-product-item">
            <div class="search-product-wrap">
              <div class="search-product-card">
                <div class="search-product__image">
                  <a href="/products/${typeof(queryData.mappings.core.url) != 'undefined' ? queryData.mappings.core.url : ''}">
                    <div class="search-image__aspect">
                      <img src="${queryData.mappings.core.imageUrl}" alt="${queryData.mappings.core.name}" width="" height="">
                    </div>
                  </a>
                </div>
                <div class="search-product__content">
                  <div class="search-product-title-wrapper">
                    <div class="search-product-title-item-wrapper">
                      <h3 class="search-product-title">
                        <a class="search-product-title-link">${queryData.mappings.core.name.split('-')[0]}</a>
                      </h3>
                      <span class="search-product-option-label">${typeof(queryData.mappings.core.name.split('-')[1]) != "undefined" ? queryData.mappings.core.name.split('-')[1] : ""}</span>                      
                    </div>
                    <div class="search-product--price__price-wrapper${queryData.attributes.tags.includes('not for sale') ? " not-for-sale" : ""}">
                      <span class="search-product--price-price product-match-price-trending trending-product-${queryData.id}"></span>
                      <span class="search-product--price-price product-match-compare-price-trending search-product-${queryData.id} hide"></span>
                    </div>
                  </div>
                </div>                  
              </div>
            </div>
          </div>`;
        }
        $(".search-seggestion-outer .searchGrid-right .search-product--items.search-trending-product").html(trendingProduct);
      }
    /* render trending product data - end */
  }


  if(arrCommonData['apiRequestData'] == 'suggestApi'){
    if(arrCommonData['responseResultData']['alternatives'].length > 0){
      var suggestApiRender = '';
      var suggestApiRenderMob = '';      
      var queryDataArr = arrCommonData['responseResultData']['alternatives'];      
      for( var prokey in  queryDataArr ){
        var queryData = queryDataArr[prokey];
        var highlightedSuggestion = queryData.text.replace(new RegExp(arrCommonData['apiRequestInput'], "gi"), match => `<span class="highlight">${match.trim()}</span>`);        
        suggestApiRender += `<li class="nav-item">
              <a href="/pages/${searchPageRedirection}?q=${queryData.text}" title="${queryData.text}">
                ${highlightedSuggestion}
              </a>
          </li>`;
        suggestApiRenderMob += `<li class="mobile-nav-item">
          <a href="/pages/${searchPageRedirection}?q=${queryData.text}" title="${queryData.text}">
            ${highlightedSuggestion}
          </a></li>`;
      }      
      $(".search-seggestion-outer .searchGrid-left .grid-title").html('Search suggestions');
      $(".search-seggestion-outer .search-navList.search-suggest").html(suggestApiRender);      
      $(".mobile-search-suggest-outer .mobile-search-inner-suggestion .mobile-search-navList").html(suggestApiRenderMob);

      //$(".search-seggestion-outer .viewAll-search").html('View All Results for <b><u>'+arrCommonData['apiRequestInput']+ '</u></b>').attr("href", `/pages/${searchPageRedirection}?q=${arrCommonData['apiRequestInput']}`);
      if($(".tt-mobile-header").css("display") !== "none"){
        $(".mobile-search-suggest-outer .mobile-search-inner-trending").css('display',"none"); 
        $(".mobile-search-suggest-outer .mobile-search-inner-suggestion").css('display',"block");
      }
      $(".search-seggestion-outer .search-navList.trending-search").css('display','none');
      $(".search-seggestion-outer .search-navList.search-suggest").css('display','block');
      suggestApiFlagNoRes = false;
      if(!$(".mobile-search-suggest-outer").is(":visible")){
        $(".mobile-search-suggest-outer").css('display',"block");  
      }
    }else{
      // if($(".mobile-search-suggest-outer").is(":visible")){
      //   $(".mobile-search-suggest-outer").css('display',"none");  
      // }
      $(".mobile-search-inner .mobile-nav-item .highlight").css('font-weight', 'unset');
      $(".search-seggestion-outer .searchGrid-left .nav-item .highlight").css('font-weight', 'unset');
      suggestApiFlagNoRes = true;
    }
  }

  if(arrCommonData['apiRequestData'] == 'searchResult'){
    if(arrCommonData['responseResultData']['results'].length > 0){
      var searchResultProduct = '';
        var queryDataArr = arrCommonData['responseResultData']['results'];        
        for( var prokey in  queryDataArr ){
          var queryData = queryDataArr[prokey];
          jQuery.getJSON(window.Shopify.routes.root + 'products/'+ queryData.handle+'.js', function(product) {
            if(cartCurrencySymbol == "$"){
              $(`.search-products .product-match-price.search-product-${product.id}`).html(Shopify.formatMoney(product.price, money_format) +" "+ localizationCurrecyCode);
              $(`.search-products .product-match-compare-price.search-product-${product.id}`).html(Shopify.formatMoney(product.compare_at_price, money_format) +" "+ localizationCurrecyCode);
            }else{
              $(`.search-products .product-match-price.search-product-${product.id}`).html(Shopify.formatMoney(product.price, money_format));
              $(`.search-products .product-match-compare-price.search-product-${product.id}`).html(Shopify.formatMoney(product.compare_at_price, money_format));
            }
            if(parseInt(product.compare_at_price) > parseInt(product.price) ){
              $(`.search-products .product-match-compare-price.search-product-${product.id}`).removeClass('hide');
            }
          });
          searchResultProduct += `<div class="search-product-item">
            <div class="search-product-wrap">
              <div class="search-product-card">
                <div class="search-product__image">
                  <a href="/products/${typeof(queryData.handle) != 'undefined' ? queryData.handle : ''}" data-uid="${queryData.uid}" data-intellisuggestData="${queryData.intellisuggestData}" data-intellisuggestSignature="${queryData.intellisuggestSignature}">
                    <div class="search-image__aspect">
                      <img src="${typeof(queryData.imageUrl) != 'undefined' ? queryData.imageUrl : `${window.location.origin}/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_600x.progressive.gif.jpg`}" alt="${queryData.name}" width="" height="">
                    </div>
                  </a>
                </div>
                <div class="search-product__content">
                  <div class="search-product-title-wrapper">
                    <div class="search-product-title-item-wrapper">
                      <h3 class="search-product-title">
                        <a class="search-product-title-link">${queryData.name.split('-')[0]}</a>
                      </h3>
                      <span class="search-product-option-label">${typeof(queryData.name.split('-')[1]) != "undefined" ? queryData.name.split('-')[1] : ""}</span>                      
                    </div>
                    <div class="search-product--price__price-wrapper${queryData.tags.includes('not for sale') || queryData.tags.includes('Not For Sale') ? " not-for-sale" : ""}">
                      <span class="search-product--price-price product-match-price search-product-${queryData.uid}"></span>
                      <span class="search-product--price-price product-match-compare-price search-product-${queryData.uid} hide"></span>
                    </div>
                  </div>
                </div>                  
              </div>
            </div>
          </div>`;
        }
        //$(".search-seggestion-outer .viewAll-search").html('View All Results for <b><u>'+arrCommonData['apiRequestInput']+ '</u></b>').attr("href", `/pages/${searchPageRedirection}?q=${arrCommonData['apiRequestInput']}`);
        $(".search-seggestion-outer .searchGrid-right .grid-title").html('Product matches');
        $(".search-seggestion-outer .searchGrid-right .no-product").css("display","none");
        $(".search-seggestion-outer .searchGrid-right .search-product--items.search-products").html(searchResultProduct);
        $(".search-seggestion-outer .searchGrid-right .search-product--items.search-trending-product").css('display','none');
        $(".search-seggestion-outer .searchGrid-right .search-product--items.search-products").css('display','block');
        searchResultFlagNoRes = false;
        if($(".search-products .search-product-item").length > 0){
          $(".search-products .search-product__image a").each(function( index ) {
            if(!$(this).hasClass("data-intellisuggestdata-autocomplete")){
              $(this).on('click', function(){
                var uid = $(this).attr('data-uid');
                sendAutocompleteBeacon(searchSpringId, ssAutocompleteResponseId, uid, ssPageLoadId);

                var data = $(this).attr('data-intellisuggestdata');
                var signature = $(this).attr('data-intellisuggestsignature');
                var elementURL = $(this).attr('href');

                IntelliSuggest.clickItem($(this), { siteId: searchSpringId , intellisuggestData : data , intellisuggestSignature : signature, href: elementURL });
              });
              $(this).addClass("data-intellisuggestdata-autocomplete");
            }
          });         
        }
    }else{
      searchResultFlagNoRes = true;
    }    
  }
 
  // if(suggestApiFlagNoRes && searchResultFlagNoRes){
  //   if($(".bg-opacity").length > 0){
  //     $(".bg-opacity").click();
  //   }
  // }
}
/* ==============  Function for common data after get responce of SearchSpringAPI end   ============== */


/* ==============  Function for search Page data after get 0 record of SearchSpringAPI Start   ============== */
function manageTrendingSearchData(arrSearchProdData){  
  if(arrSearchProdData['ProductResults'].length > 0){  
    for (let i = 0; i <+ arrSearchProdData['ProductResults'].length; i++) {
      var searchDataResult = arrSearchProdData['ProductResults'][i];      
      var variantSearchHTML = '';
      if(typeof(searchDataResult.attributes.variants) != "undefined"){
        var variantsArr = JSON.parse(searchDataResult.attributes.variants.replace(/&quot;/g,'"'));
        for (var j = 0; j < variantsArr.length; j++) {
          var dataAvailability = false;
          if(geoLocationCode != "US" && searchDataResult.attributes.tags.includes("Global-e Restricted")){
            dataAvailability = false;
          }else if(variantsArr[j].inventory_management === 'shopify' && variantsArr[j].inventory_policy === 'continue' && variantsArr[j].inventory_quantity <= 0){
            dataAvailability = true;
          }else{
            if(variantsArr[j].inventory_quantity > 0){
              dataAvailability = true;
            }else{
              dataAvailability = false;
            }
          }
          variantSearchHTML += `<li 
                class="sizeCls"
                data-availability="${dataAvailability}"
                data-variant_availability="${dataAvailability}"              
                data-var_id="${variantsArr[j].id}"
                data-pr_id="${searchDataResult.uid}"
                data-tag="${variantsArr[j].option1}"
                data-price="${(variantsArr[j].price * 100)}"
                data-buttonname="${(variantsArr[j].inventory_management == 'shopify' && variantsArr[j].inventory_policy == 'continue' && variantsArr[j].inventory_quantity <= 0) ? '<span>PRE-ORDER</span>' : '<span>ADD TO BAG</span>'}"
                data-compprice="${(variantsArr[j].compare_at_price * 100)}"
              >
                <a href="#">
                  ${typeof(variantsArr[j].mfield_custom_product_size_description_label) != 'undefined' ? variantsArr[j].mfield_custom_product_size_description_label : variantsArr[j].option1 }
                </a>
              </li>`;
        }
      }
      
      var pJpg = [360,450,520,600];           
      if(typeof(searchDataResult.mappings.core.imageUrl) != 'undefined'){
        var ImgInfo = searchDataResult.attributes.images.split("|")[0];
        var ImgHoverInfo = searchDataResult.attributes.images.split("|")[1]        
        if(ImgInfo != "" && typeof(ImgInfo) != "undefined"){
            var FileExt = ImgInfo.split('.').pop();        
            var arrFileDetails = ImgInfo.split('.'+FileExt);            
            var newArrFileDetails = arrFileDetails[0].split('https:');        
            var newImgSrc = '';
            if(typeof(ImgHoverInfo) != 'undefined'){
              var FileHoverExt = ImgHoverInfo.split('.').pop();
              var arrFileDetailsHover = ImgHoverInfo.split('.'+FileHoverExt);
              var newArrFileDetailsHover = arrFileDetailsHover[0].split('https:'); 
            }          
            var newHoverImgSrc = '';
            for(var j in pJpg){
                newImgSrc = newImgSrc + newArrFileDetails[1] + "_" + pJpg[j] + "x.progressive." + FileExt + " " + pJpg[j]+"w, ";
                if(typeof(ImgHoverInfo) != 'undefined'){
                  newHoverImgSrc = newHoverImgSrc + newArrFileDetailsHover[1] + "_" + pJpg[j] + "x.progressive." + FileExt + " " + pJpg[j]+"w, ";
                }
            }
        }
      }else{
        var noImgURL = `${window.location.origin}/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c`;
        var newImgSrc = '';
        var newHoverImgSrc = '';
        for(var j in pJpg){
            newImgSrc = newImgSrc + noImgURL + "_" + pJpg[j] + "x.progressive.gif.jpg" + " " + pJpg[j]+"w, ";
            if(typeof(ImgHoverInfo) != 'undefined'){
              newHoverImgSrc = newHoverImgSrc + noImgURL + "_" + pJpg[j] + "x.progressive.gif.jpg" + " " + pJpg[j]+"w, ";
            }
        }
      }

      var swatchCollection = "";
      var fabricTag = ``;
      var colorSwatchCount = 0;
      var notForSale = false;      
      for (let i = 0; i < searchDataResult.attributes.tags.length; i++) {
        if (searchDataResult.attributes.tags[i].toLowerCase().startsWith('fabric-')) {
            fabricTag = searchDataResult.attributes.tags[i].split("fabric-")[1];
        }

        if (searchDataResult.attributes.tags[i].toLowerCase().startsWith('not for sale')) {
            notForSale = true;
        }
      }

      for (let i = 0; i < searchDataResult.attributes.collection_name.length; i++) {
        if(searchDataResult.attributes.collection_name[i].toLowerCase().startsWith("swatchgroup-")){
          swatchCollection = searchDataResult.attributes.collection_name[i].toLowerCase();
        }
      }
      
      var searchDataHTML = `
        <div class="tt-col-item" data-page="1" data-product-id="${searchDataResult.mappings.core.uid}" data-default-handle="${searchDataResult.mappings.core.url}">
          <div class="respimgsize tt-product product-parent options-js product-nohover">
        
            <div class="tt-image-box">
              <button data-with-epi="true" class="swym-button custom-wishlist-button swym-add-to-wishlist-view-product product_${dataResult.uid}" aria-label="Add to Wishlist" data-swaction="addToWishlist" data-product-id="${dataResult.uid}" data-variant-id="${JSON.parse(dataResult.variants.replace(/&quot;/g,'"'))[0].id}" data-product-url="${window.location.origin}/products/${dataResult.handle}"></button>
              ${notForSale ? '' : `<div class="size-variant"></div>`}
              <a href="/products/${searchDataResult.mappings.core.url}" class="img-link">
                <span class="tt-img 11">
                    <img class="lazyload" data-mainimageratio="1.0" srcset="${newImgSrc}" alt="${searchDataResult.name}">
                </span>                 
                ${newHoverImgSrc != '' ? `
                  <span class="tt-img-roll-over">
                    <img class="lazyload" srcset="${newHoverImgSrc}" alt="${searchDataResult.mappings.core.name}">
                  </span>
                ` : '' }                  
              </a>
            </div>
  
            <div class="tt-description">
              <div class="ptitle-price-wrap">
                  <h2 class="tt-title prod-thumb-title-color">
                      <a href="/products/${searchDataResult.mappings.core.url}" class="">
                        ${("false" == 'true') ? searchDataResult.mappings.core.name.substring(0, "5") + '"..."' : searchDataResult.mappings.core.name.split("-")[0] }
                      </a>
                      <span class="selected-color current-color-${searchDataResult.mappings.core.uid}">${searchDataResult.mappings.core.name.split("-")[1]}</span>
                  </h2>
                  <div class="tt-price${notForSale ? " not-for-sale" : ""}">
                    <span class="price price-${searchDataResult.mappings.core.uid}">${Shopify.formatMoney((searchDataResult.mappings.core.price * 100), money_format) +" "+ localizationCurrecyCode}</span>
                    <span class="old-price old-price-${searchDataResult.mappings.core.uid} hide"></span>
                  </div>
              </div>
  
              <div class="variant-fabric">
                <div class="variant-tags">
                  <div class="tt-option-block">
                    <div class="size-move-data">
                      <div class="size-position">
                        <span class="quick-add">Quick Add</span>
                        <ul class="tt-options-swatch productitem-option1-js color-opt size-ul variant-outer-${searchDataResult.mappings.core.uid}">${variantSearchHTML}</ul>
                      </div>
                    </div>
                    <div class="color-wrap uniqueId-${searchDataResult.mappings.core.uid}">
                      <span class="no_of_clr on_hover">
                        <span class="pre-colourCount-${searchDataResult.mappings.core.uid}"></span><span class="post-colourCount-${searchDataResult.mappings.core.uid}"></span>
                      </span>
                    </div>
                  </div>
                </div>
  
                ${fabricTag != "" ? `<div class="fabric-tag"><span>Fabric: </span><strong>${fabricTag}</strong></div>` : ''}
              </div>
  
              <div class="tt-product-inside-hover">
                <div class="tt-row-btn">
                  <form action="/cart/add" data-productid="${searchDataResult.mappings.core.uid}" method="post" enctype="multipart/form-data">
                    <input type="hidden" name="id" data-productid="${searchDataResult.uid}" value="">
                    ${searchDataResult.attributes.tags.includes("Final Sale") ? `<input type="hidden" class="finalSale" name="properties[_final_sale]" data-productid="${searchDataResult.uid}" value="Y">` : ""} 
                    <button class="tt-btn-addtocart ${ ("true" == 'true') ? 'addtocart-item-js' : ''} thumbprod-button-bg" >
                      <span>ADD TO BAG</span>
                    </button>
                  </form>
                </div>            
              </div>
            </div>
          </div>
        </div>
      `;
  
      /* Color swatch ajax on page */
      
      if (i == 0) {
        originalPrice = searchDataResult.mappings.core.price;
        jQuery.getJSON(window.Shopify.routes.root + 'products/'+ searchDataResult.mappings.core.url+'.js', function(product) {        
          convertedPrice = product.price;
        });    
      }
      $.ajax({
        url: `/pages/collection-colorswatch/${swatchCollection};${searchDataResult.mappings.core.uid};${searchDataResult.mappings.core.url}`,
        type: 'GET',        
        success: function(data) {
          var uniqueId = $(data).find('#uniqueId').html();
          $(".variant-outer-"+uniqueId+" li").each(function( index ) {
            var curVarId = $(this).attr('data-var_id');
            var newPrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .price').html();
            var newComparePrice = $(data).find('.variant-info-'+uniqueId+' .variant-'+curVarId+' .comp-price').html();
            $(this).attr('data-price', newPrice);
            $(this).attr('data-compprice', newComparePrice);
          });
          var colorSwatchCount = $(data).find('#swatchCount').html();          
          var preHtml = colorSwatchCount > 0 ? colorSwatchCount : "No";
          var postHtml = colorSwatchCount === 1 ? "&nbsp;color available" : "&nbsp;colors available";
          $('.pre-colourCount-' + uniqueId).html(preHtml);
          $('.post-colourCount-' + uniqueId).html(postHtml);          
          var colorSwatchBox = $(data).find('#colorSwatch-box').html();        
          $('.tt-description .color-wrap.uniqueId-'+uniqueId).append(colorSwatchBox);
  
          var currentColor = $(data).find("#colorSwatch-box li.active a").attr("data-color");
          $('.current-color-'+uniqueId).html(currentColor);
  
          var currentPrice = $(data).find("#productPrice").html();
          var currentCompPrice = $(data).find("#productCompPrice").html();

          if(cartCurrencySymbol != "$"){
            $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format));
            $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format));
          }else{
            $('.tt-price .price-'+uniqueId).html(Shopify.formatMoney(currentPrice, money_format) +" "+ localizationCurrecyCode);  
            $('.tt-price .old-price-'+uniqueId).html(Shopify.formatMoney(currentCompPrice, money_format) +" "+ localizationCurrecyCode);
          }
     
          if(parseInt(currentCompPrice) > parseInt(currentPrice)){
             $('.tt-price .old-price-'+uniqueId).removeClass('hide');
             $('.tt-price .price-'+uniqueId).addClass('new-price');
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error fetching line-item-list content:", errorThrown);
        }
      });      
      $(".tt-product-listing").append(searchDataHTML);
    }

    setTimeout(() => {
      // color_update(true);
      color_swatches_function();
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    },1000);
    collectionSizeChart();
  }  
}
/* ==============  Function for search Page data after get 0 record of SearchSpringAPI end   ============== */


/* ==============  Function for call SearchSpringAPI start   ============== */
function callSearchSpringAPI( arrApiParams ){
    var url = arrApiParams['baseURL'];
    var ajaxResponse = [];     
    var queryParamsURL = '';   
    for (var key in arrApiParams['urlParms']) {
      if (queryParamsURL != "") {
        queryParamsURL += "&";
      }
      if(typeof(arrApiParams['urlParms'][key]) == 'object'){
        for ( var valueKey in arrApiParams['urlParms'][key] ){          
          if (queryParamsURL != "" && queryParamsURL.charAt(queryParamsURL.length - 1) != "&") {
            queryParamsURL += "&";
          }
          queryParamsURL += key + "=" + encodeURIComponent(arrApiParams['urlParms'][key][valueKey]);          
        }
      }else{
        queryParamsURL += key + "=" + encodeURIComponent(arrApiParams['urlParms'][key]);
      }      
    }    
    var searchSpringAPIURL = url+"?"+queryParamsURL;
  
    if( false ){
      console.log("New arrApiParams:", arrApiParams);
      console.log("url", url);
      console.log("queryParamsURL", queryParamsURL);
      console.log("searchSpringAPIURL", searchSpringAPIURL);
      console.log("featureProductParams", arrApiParams['featureProductParams']);
    }  
    var asyncParam = true;
    if(typeof(arrApiParams['featureProductParams']) != "undefined" && arrApiParams['featureProductParams'] == "Y" && arrApiParams['page'] <= 1){
      asyncParam = false;
    }else{
      asyncParam = true;
    }  
    var settings = {
      async: asyncParam,
      crossDomain: true,
      url: searchSpringAPIURL,
      method: 'GET',
      headers: {
        accept: 'application/json'
      }
    };

    $.ajax(settings).done(function (response) {

       /* check and redirect if redirection is set or not for search query - start */
        
        if( ( arrApiParams['pageRequest'] != "common" && page_template == 'page.search-result-searchspring' && typeof(response.merchandising) != "undefined" ) && (typeof(response.merchandising.redirect) != "undefined" && response.merchandising.redirect != "") ) {
           window.location.href = response.merchandising.redirect;
           return false;
        }
      
        /* check and redirect if redirection is set or not for search query - end */

      if(typeof(arrApiParams['featureProductParams']) != "undefined" && response.results.length > 0 && arrApiParams['featureProductParams'] == "Y" && arrApiParams['page'] <= 1 && featuredProductHandle.includes(response?.results?.[0]?.handle)){
         featuredProductArr = [];          
      }
      
      if(typeof(arrApiParams['featureProductParams']) != "undefined" && arrApiParams['featureProductParams'] == "Y" && response.results.length <= 0 && arrApiParams['page'] <= 1){
         featuredProductArr = [];
      }

      var flag = false;
      if(arrApiParams['pageRequest'] == "collection"){
        if(response.results.length > 0){
           flag = true;
        }
      }else{
        flag = true;
      }
      
      if(typeof(arrApiParams['featureProductParams']) != "undefined" && arrApiParams['featureProductParams'] == "Y" && arrApiParams['pageRequest'] == "collection" && response.results.length > 0 && featuredProductHandle.includes(response?.results?.[0]?.handle) && ((response.results.length == featuredProductHandle.length) ||  featuredProductHandle.length > 0) && arrApiParams['page'] <= 1){
        featuredProductArr = [];
        featuredProductArrRes = response.results;
        if(featuredProductHandle.length > 1){
          featuredProductHandle.forEach(ProductHandle => {
              featuredProductArrRes.forEach(featuredProduct => {
                  if(featuredProduct.handle == ProductHandle){
                    featuredProductArr.push(featuredProduct);
                  }
              });
          });
        }else{
          featuredProductArr = featuredProductArrRes
        }
        
        featuredProductArr = featuredProductArr.filter((item, index, self) =>
            index === self.findIndex(t => t.handle === item.handle)
        );        
      }else if(flag){
        switch(arrApiParams['pageRequest']) {
        case "collection" :            
            /* Process Collection Page Data  */
            var arrCollectionData = [];
            var newResponseResultArr = [];
            
            if(featuredProductArr.length > 0 && arrApiParams['page'] <= 1){              
              var filteredResultsTemp = response.results.filter(result => 
                  !featuredProductArr.some(featured => featured.handle === result.handle)
              );
              newResponseResultArr = featuredProductArr.concat(filteredResultsTemp);
            }else{
              var filteredResultsTemp = response.results.filter(result => 
                  !featuredProductArr.some(featured => featured.handle === result.handle)
              );
              newResponseResultArr = filteredResultsTemp;
            }
            arrCollectionData['page'] = response.pagination.currentPage;
            arrCollectionData['feturedProductResponse'] = "N";
            /*  response.singleResult for the featured product response */                      
            if( typeof(response.singleResult) != "undefined" && featuredProductHandle.includes(response.singleResult) ){
                arrCollectionData['feturedProductResponse'] = "Y";
                if( typeof(response.results) != "undefined" && response.results.length > 0 ) {
                    arrCollectionData['collectionProductResults'] = response.results;
                }
                if( typeof(response.pagination) != "undefined" ) {
                    arrCollectionData['pagination'] = response.pagination;
                }
            } else{
                if( typeof(newResponseResultArr) != "undefined" && newResponseResultArr.length > 0 ) {
                    arrCollectionData['collectionProductResults'] = newResponseResultArr;
                }
                if( typeof(response.pagination) != "undefined" ) {
                    arrCollectionData['pagination'] = response.pagination;
                }
                if( typeof(response.sorting.options) != "undefined" && response.sorting.options.length > 0 ) {
                    arrCollectionData['sorting'] = response.sorting;
                }
                if( typeof(response.facets) != "undefined" && response.facets.length > 0 ) {
                    arrCollectionData['facets'] = response.facets;
                }                
            }            ;
        break;
          
        case "product":          
          var arrProductData = [];
          arrProductData['ProductResults'] = response[0].results;
        break;

        case "searchWithNoRec" :
          var arrSearchWithNoRecData = [];
          arrSearchWithNoRecData['ProductResults'] = response[0].results;
          manageTrendingSearchData(arrSearchWithNoRecData);          
        break;
          
        case "common" :
          var arrCommonnData = [];          
          if(arrApiParams['apiRequest'] == 'trending'){
            arrCommonnData['apiRequestData'] = arrApiParams['apiRequest'];
            arrCommonnData['responseResultData'] = response;
          }
          if(arrApiParams['apiRequest'] == 'trendingProductRec'){
            arrCommonnData['apiRequestData'] = arrApiParams['apiRequest'];
            arrCommonnData['responseResultData'] = response;
          }          
          if(arrApiParams['apiRequest'] == 'suggestApi'){
            arrCommonnData['apiRequestData'] = arrApiParams['apiRequest'];
            arrCommonnData['apiRequestInput'] = arrApiParams['urlParms']['q'];
            arrCommonnData['responseResultData'] = response;
          }
          if(arrApiParams['apiRequest'] == 'searchResult'){
            arrCommonnData['apiRequestData'] = arrApiParams['apiRequest'];
            arrCommonnData['apiRequestInput'] = arrApiParams['urlParms']['q'];
            arrCommonnData['responseResultData'] = response;
            ssAutocompleteResponseId = response.responseId || null;
          }          
          manageCommonData(arrCommonnData);
        break;
      }
      }
    });
}
/* ==============  Function for call SearchSpringAPI end   ============== */


/* ==============  Function for onScroll api for SearchSpringAPI start   ============== */
myInterval = setInterval(function () {  
  if($('.autoscroll_yes').length > 0){
    clearInterval(myInterval);
    $(window).scroll(function(){
      autoscrollhandler();
    });
  }
}, 1000);

function autoscrollhandler(){
  var _as = $('.autoscroll');
  if(_as.length == 0) return false;
  var contY = parseInt(_as.parent().offset().top);
  var wY = getWindowHeight()+getWindowTopY();  
  if( contY <= wY ) {
    _as.removeClass('autoscroll').trigger('click');
  }
}
/* ==============  Function for onScroll api for SearchSpringAPI end   ============== */


/* ==============  SearchSpring Common API Function start   ============== */

function trendingSearchResultAPI(){
  var apiParams = [];
  var trendinglimit = 5;
  apiParams['pageRequest'] = 'common';
  apiParams['apiRequest'] = 'trending';
  apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/suggest/trending`;
  apiParams['urlParms'] = [];
  apiParams['urlParms']['siteId'] = `${searchSpringId}`;
  apiParams['urlParms']['limit'] = `${trendinglimit}`;  
  callSearchSpringAPI(apiParams);
}

function trendingSearchProductResultAPI(){
  var apiParams = [];
  apiParams['pageRequest'] = 'common';
  apiParams['apiRequest'] = 'trendingProductRec';
  var trendingProductRec = 3;
  apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/boost/${searchSpringId}/recommend`;
  apiParams['urlParms'] = [];
  apiParams['urlParms']['tags'] = `trending-products`;
  apiParams['urlParms']['limits'] = `${trendingProductRec}`;  
  callSearchSpringAPI(apiParams);
}

function SearchSuggestionsResultAPI(element){
  if(element.value.trim().length > 0){
    var apiParams = [];
    var suggestionCount = 6;
    apiParams['pageRequest'] = 'common';
    apiParams['apiRequest'] = 'suggestApi';
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/suggest/query`;
    apiParams['urlParms'] = [];
    apiParams['urlParms']['siteId'] = `${searchSpringId}`;    
    apiParams['urlParms']['q'] = element.value;
    apiParams['urlParms']['bgfilter.ss_is_published'] = 1;
    apiParams['urlParms']['bgfilter.ss_visibility'] = "search";
    apiParams['urlParms']['suggestionCount'] = `${suggestionCount}`;    
    callSearchSpringAPI(apiParams);
  }else{
      $(".search-seggestion-outer .viewAll-search").html('View All Results').attr("href", `/pages/${searchPageRedirection}?q=`);
      $(".search-seggestion-outer .searchGrid-left .grid-title").html('Trending searches');
      $(".search-seggestion-outer .searchGrid-right .grid-title").html('Trending products');      
      $(".search-seggestion-outer .search-navList.search-suggest").css('display','none');
      $(".search-seggestion-outer .search-navList.trending-search").css('display','block');
      $(".search-seggestion-outer .searchGrid-right .search-product--items.search-products").css('display','none');
      $(".search-seggestion-outer .searchGrid-right .search-product--items.search-trending-product").css('display','block');
      $(".mobile-search-suggest-outer .mobile-search-inner.mobile-search-inner-trending").css('display','block');
      $(".mobile-search-suggest-outer .mobile-search-inner.mobile-search-inner-suggestion").css('display','none');
  }
  if(!$(".bg-opacity .tt-search-opened-headtype1 form .search-seggestion-outer").is(":visible") && !suggestApiFlagNoRes && !searchResultFlagNoRes){
    $("#tt-search-input").click();
  }  
}

function SearchSuggestionsProductResultAPI(element){
  if(element.value.trim().length > 0){
    var apiParams = [];
    var resultPerPageCount = 3;
    apiParams['pageRequest'] = 'common';
    apiParams['apiRequest'] = 'searchResult';
    apiParams['baseURL'] = `https://${searchSpringId}.a.searchspring.io/api/search/autocomplete.json`;
    apiParams['urlParms'] = [];
    apiParams['urlParms']['siteId'] = `${searchSpringId}`;    
    apiParams['urlParms']['q'] = element.value;
    apiParams['urlParms']['resultsFormat'] = 'json';
    apiParams['urlParms']['bgfilter.ss_is_published'] = 1;
    apiParams['urlParms']['bgfilter.ss_visibility'] = "search";
    apiParams['urlParms']['resultsPerPage'] = `${resultPerPageCount}`;    
    callSearchSpringAPI(apiParams);
  }else{
    $(".search-seggestion-outer .viewAll-search").html('View All Results').attr("href", `/pages/${searchPageRedirection}?q=`);      
    $(".search-seggestion-outer .searchGrid-left .grid-title").html('Trending searches');
    $(".search-seggestion-outer .searchGrid-right .grid-title").html('Trending products');    
    $(".search-seggestion-outer .search-navList.search-suggest").css('display','none');
    $(".search-seggestion-outer .search-navList.trending-search").css('display','block');
    $(".search-seggestion-outer .searchGrid-right .search-product--items.search-products").css('display','none');
    $(".search-seggestion-outer .searchGrid-right .search-product--items.search-trending-product").css('display','block');
  }
}

function callSearchSpringCommonAPI(){
  var inputElement = document.getElementById("tt-search-input");
  var inputElementMob = document.getElementById("tt-search-input-mob");
  if ($(".tt-mobile-header").css("display") !== "none") {
    trendingSearchResultAPI();
    
    inputElementMob.addEventListener("keyup", function(event) {
      var serchTxt = $("#tt-search-input").val();
      $(".search-seggestion-outer .viewAll-search").html('View All Results for <b><u>'+serchTxt+ '</u></b>').attr("href", `/pages/${searchPageRedirection}?q=${serchTxt}`);
      
      setTimeout(function(){
        SearchSuggestionsResultAPI(inputElementMob);
      }, 5);
    });
    
    if(document.getElementById("tt-search-input-mob").value != ""){
        SearchSuggestionsResultAPI(inputElement);        
    }
  }else{
    trendingSearchResultAPI();
    trendingSearchProductResultAPI();    
    
    inputElement.addEventListener("keyup", function(event) {

      var serchTxt = $("#tt-search-input").val();
      $(".search-seggestion-outer .viewAll-search").html('View All Results for <b><u>'+serchTxt+ '</u></b>').attr("href", `/pages/${searchPageRedirection}?q=${serchTxt}`);
      
      setTimeout(function(){
        SearchSuggestionsResultAPI(inputElement);
        SearchSuggestionsProductResultAPI(inputElement);
      }, 5);
    });

    if(document.getElementById("tt-search-input").value != ""){
        SearchSuggestionsResultAPI(inputElement);
        SearchSuggestionsProductResultAPI(inputElement);
    }
  }

  if($(".tt-mobile-parent-search .tt-dropdown-toggle").length > 0){
  	$(".tt-mobile-parent-search .tt-dropdown-toggle").on("click", function() {
  		if($(".mobile-search-suggest-outer").is(":visible")){
  			$(".mobile-search-suggest-outer").css("display","none");
  		}
  	});
  }

  if($(".tt-mobile-parent-search .tt-dropdown-menu .tt-search-input").length > 0){
    $(".tt-mobile-parent-search .tt-dropdown-menu .tt-search-input").on("click", function() {
  		if(!$(".mobile-search-suggest-outer").is(":visible")){
  			$(".mobile-search-suggest-outer").css("display","block");
  		}
  	});
  }
}

/* ==============  SearchSpring Common API Function end   ============== */




/* ==============  SearchSpring product Beacon API Function Start   ============== */
function callSearchSpringBeaconAPI(beaconParams){
    $.ajax({
      url: 'https://beacon.searchspring.io/beacon',
      method: 'POST',
      headers: {
          accept: 'application/json',
          'content-type': 'application/json'
      },
      data: JSON.stringify(beaconParams),
      success: function(response) {        
        console.log(response);
      },
      error: function(err) {
          console.error(err);
      }
    });
}

function callBeaconApiForProductRender(arrProductProfile){ 
  let arrayOfObjectsForProducts = [];
  let randomID = self.crypto.randomUUID();
  let pageLoadSearchID = self.crypto.randomUUID();
  /* object for profile render */
  let objProfileRender = {
      "category": "searchspring.recommendations.user-interactions",
      "context": {
          "sessionCookie": ssSessionIdNamespaceCookie,
          "userId": ssUserIdCookie,
          "pageLoadId": pageLoadSearchID,
          "website": {
              "trackingCode": searchSpringId
          }
      },
      "type": "profile.render",
      "id": randomID,
      "event": {
          "context": {
              "type": "product-recommendation",
              "tag": "similar",
              "placement": "product-page"
          },
          "profile": {
              "tag": "similar",
              "placement": "product-page",
              "seed": []
          }
      }
  }

  arrayOfObjectsForProducts.push(objProfileRender);

  var baseApiObj  = {
      "category": "searchspring.recommendations.user-interactions",
      "context": {
          "sessionCookie": ssSessionIdNamespaceCookie,
          "userId": ssUserIdCookie,          
          "website": {
              "trackingCode": searchSpringId
          }
      },
      "type": "profile.product.render",  
      "event": {
          "context": {
              "type": "product-recommendation",
              "tag": "similar",
              "placement": "product-page"
          },
          "product": {             
              "seed": []
          }
      }
  }

  arrProductProfile['ProductResults'].forEach(productResult => {      
      const productObject = JSON.parse(JSON.stringify(baseApiObj));

      const tempPageLoadId = self.crypto.randomUUID();
      const tempId = self.crypto.randomUUID();
            
      productObject.event.product.id = productResult.id;
      productObject.event.product.mappings = productResult.mappings;
            
      productObject.context.pageLoadId = tempPageLoadId;
      productObject.id = tempId;
    
      arrayOfObjectsForProducts.push(productObject);
  });

  callSearchSpringBeaconAPI(arrayOfObjectsForProducts);
  
}
/* ==============  SearchSpring product Beacon API Function End   ============== */




/* ==============  Search Spring required Cookie generation Start   ============== */
manageSearchSpringCookie();
/* ==============  Search Spring required Cookie generation end   ============== */

/* set common Constant for searchspring start  */
var searchSpringId = "jkgnc5";
const resultPerPage = 25;
var currentDomain = window.location.pathname+location.search;
var page_template = pageTemplate;
var hasFeaturedProduct = false;
var featuredProductHandle = [];
var ssUserIdCookie = getSearchSpringCookie('ssUserId');
var ssSessionIdNamespaceCookie = getSearchSpringCookie('ssSessionIdNamespace');

var currentSiteURL = `${window.location.origin}${window.location.pathname}${location.search}`;

var getSearchParams = getFilterParams(currentSiteURL);
if(getSearchParams.featuredURL != ''){
  var featuredURLParams = getSearchParams.featuredURL.split('featured=')[1];
  featuredProductHandle = featuredURLParams.split(',');    
}
/* set common Constant for searchspring end  */
switch(page_template) {
  case "collection":
    callSearchSpringCommonAPI();
  break;
  
  case "searchspring-seach":
  break;

  case "page.search-result-searchspring":    
    callSearchSpringCommonAPI();
  break;
  
  case "product":
    callSearchSpringCommonAPI();
  break;

  default:
    callSearchSpringCommonAPI();
}
